import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import clubInfo from "../club_info.json"
import EstacionamientoSmallHeader from "./Estacionamientos/EstacionamientoSmallHeader";



const EstacionamientoDonde = () => {
    const navigate = useNavigate();
  
    
    return (
        <>
        <main>
      <div className="container text-center mainContent" >
      <EstacionamientoSmallHeader texto="" retorno="/estacionamientoppal"/>
              {/*<PageTitlesBig texto="Clubes Municipales"  icono="./icon_header_clubes.svg" retorno="/actividades" subtexto={"Club "+localStorage.getItem("Actividad-Club")}/>*/}
    
    <div className="row" style={{paddingTop:"30px"}}>
        <div className="col-12 alignCenter textGreyTitle">
        Playones
        </div>
        </div>
        <div className="row">
            <div className="col-12">

            </div>
        </div>
        <div className="row">
            
                    <div className="col">
            <img src="./estacionamiento_ppal_ubic.svg" width="40px" style={{marginTop:"15px"}} />
            </div>
            </div>
            <div className="row">
                <div className="col">

            <div className="buttonContainerSpec">
                        <button className="buttonMiniClipFixed" onClick={()=>navigate("/botoneragratuitosbis")}>Ubicaciones</button>
                    </div>
                    </div>
                    </div>
            
    
    <div className="row">
        <div className="col">
        <img src="./line-h.png" width="320px"/>
        </div>
        </div>
    <div className="row">
        <div className="col">

        <img src="./estacionamiento_ppal_cred.svg" width="40px" style={{marginTop:"15px"}}/>

        <div className="buttonContainerSpec">
                        <button className="buttonMiniClipFixed" onClick={()=>navigate("/credencialbis")}>mi QR</button>
                    </div>
        </div>
        </div>
        </div>
        
</main>
        
        </>

    );
    }
export default EstacionamientoDonde;